import { useEffect, useRef } from 'react';
import { getSocket } from '../services/socket';
import { IFeedbackReply } from '../types';

/**
 * Hook that subscribes to real-time feedback replies via WebSocket.
 * When a user sends a reply, the backoffice receives it instantly.
 *
 * @param feedbackId - The currently viewed feedback ID (null if on list view)
 * @param onNewReply - Callback when a new reply arrives for the current feedback
 */
const useFeedbackSocket = (
  feedbackId: string | null,
  onNewReply: (reply: IFeedbackReply) => void,
) => {
  const onNewReplyRef = useRef(onNewReply);
  onNewReplyRef.current = onNewReply;

  useEffect(() => {
    const socket = getSocket();

    // Subscribe to backoffice feedback room
    socket.emit('feedback:subscribe');

    const handleNewReply = (reply: IFeedbackReply) => {
      if (feedbackId && reply.feedbackId === feedbackId) {
        onNewReplyRef.current(reply);
      }
    };

    socket.on('feedback:new_reply', handleNewReply);

    return () => {
      socket.off('feedback:new_reply', handleNewReply);
    };
  }, [feedbackId]);
};

export default useFeedbackSocket;
